<template>
  <div>
    <p class="cm-mg-p-wzd">
      {{ $t('diseases.plague_or_disease_fill_data') }}
    </p>
    <hr />
    <div class="row">
      <div class="col-md-6">
        <fg-input
          type="text"
          :label="`${$t('common_words.name')}: *`"
          v-model="model.name"
          name="common_words.name"
          v-validate="modelValidations.name"
          :error="getError('common_words.name', true)"
          :placeholder="`${$t('diseases.plague_or_disease_name')}...`"
          @change="getNameDisease()"
        ></fg-input>
      </div>
      <div class="col-6">
        <div class="row">
          <div class="form-group has-label col-4">
            <label>{{ $t('common_words.photograph_questionmark') }}</label>
            <br />
            <l-switch
              class="mt-2"
              v-model="model.photo"
              on-text="ON"
              off-text="OFF"
            ></l-switch>
          </div>
          <div class="form-group has-label col-4">
            <label>{{ $t('common_words.perimeter') }}?</label>
            <br />
            <l-switch
              class="mt-2"
              v-model="model.perimeter"
              on-text="ON"
              off-text="OFF"
            ></l-switch>
          </div>
          <div class="form-group has-label col-4">
            <label>{{ $t('common_words.confirm') }}?</label>
            <br />
            <l-switch
              class="mt-2"
              v-model="model.confirmation"
              on-text="ON"
              off-text="OFF"
            ></l-switch>
          </div>
        </div>
      </div>
      <div class="col-md-4">
        <fg-input
          type="text"
          :label="`${$t('diseases.scientific_name')}: `"
          v-model="model.scientific_name"
          :placeholder="`${$t(
            'diseases.plague_or_disease_scientific_name'
          )}...`"
        ></fg-input>
      </div>
      <div class="col-4">
        <div class="form-group has-label">
          <label>{{ $t('common_words.type') }}: *</label>
          <br />
          <el-select
            clearable
            filterable
            class="select-primary custom-width-select shadow-sm required-type"
            v-model="model.type_p_e"
            :placeholder="$t('diseases.plague_or_disease_questionmark')"
          >
            <el-option
              class="select-primary"
              :value="1"
              :label="$t('diseases.plague')"
            >
            </el-option>
            <el-option
              class="select-primary"
              :value="2"
              :label="$t('diseases.disease')"
            >
            </el-option>
          </el-select>
        </div>
      </div>
      <div class="form-group has-label col-2">
        <!-- <label>Informaci&oacuten</label> -->
        <label>{{ $t('common_words.spec_sheet') }}</label>
        <el-upload
          id="diseasepdf"
          :data="{ ...uploadData, disease_id: model.id }"
          :headers="headerInfo"
          class="upload-demo custom-upload"
          :action="getAxiosURL() + '/auth/diseases/diseases/uploaddiseasefile'"
          multiple
          :before-upload="emitFile"
          :limit="1"
          :file-list="model.fileList"
          :on-preview="handlePreview"
          :on-remove="handleRemoveFile"
          :on-exceed="handleExceed"
          :on-success="handleSuccess"
        >
          <el-button
            size="small"
            type="success"
            style="display: block; margin: 0 auto"
          >
            {{ $t('common_words.upload_pdf') }}
          </el-button>
        </el-upload>
      </div>
    </div>
    <!-- <div class="row"> -->
    <!-- </div> -->
    <div class="row">
      <div class="col-12">
        <div class="form-group has-label">
          <label>{{ $t('common_words.observation') }}</label>
          <br />
          <el-input
            maxlength="200"
            show-word-limit
            type="textarea"
            :rows="2"
            placeholder="..."
            v-model="model.observation"
            class="shadow-sm"
          ></el-input>
          <br />
          <br />
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="form-group has-label">
          <label>{{ $t('common_words.color') }}</label>
          <sketch-picker
            :value="colors"
            @input="updateValue"
            v-if="renderComponent"
          ></sketch-picker>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Axios } from 'src/class/Axios.js';
import { mapActions } from 'vuex';
import { convertFirstLetterUppercase } from 'src/util/Util.js';
import { Switch as LSwitch } from 'src/components';
import MixinForm from 'src/mixins/forms/mixin-form';
import MixinColors from 'src/util/mixinColor';
import mixinMasters from 'src/util/mixinMasters';
import MixinPermissions from 'src/util/mixinPermissions';
import MixinValidations from 'src/mixins/forms/mixin-validations';
import SweetAlert from 'src/class/Alerts';
import i18n from 'src/i18n';

export default {
  components: {
    LSwitch,
  },

  data() {
    return {
      model: {
        id: null,
        // user:this.$store.state.auth.user.id,
        name: null,
        observation: null,
        photo: false,
        perimeter: false,
        confirmation: false,
        color: null,
        scientific_name: null,
        type_p_e: null,
        type_p_e_name: null,
        fileList: [],
      },
      uploadData: {
        user: this.$store.state.auth.user.id,
        nameFile: '',
        // disease_id:id
      },
      headerInfo: {
        Authorization: 'Bearer ' + this.$store.state.auth.token,
      },
      modelValidations: {
        name: {
          required: true,
        },
      },
    };
  },
  mixins: [
    MixinPermissions,
    MixinForm,
    MixinColors,
    mixinMasters,
    MixinValidations,
  ],

  methods: {
    handleRemoveFile(file) {
      this.uploadData.nameFile = file.name;
      this.removeFileUpload(file);
    },

    handleExceed(files, fileList) {
      SweetAlert.warning(
        `${i18n.t('sweet_alert.ground.selected_limit')} ${
          files.length
        } ${i18n.t('sweet_alert.ground.files')} `
      );
    },

    handlePreview($event){
      const link = document.createElement("a");
      if(this.model.id !== null){
        link.href = `https://demo.smartcultivo.com/smart-backend/path_images/diseasesfiles/${this.model.id}/${$event.name}`;
      }else{
        link.href = `https://demo.smartcultivo.com/smart-backend/path_images/diseasesfiles/tmp/${this.$store.state.auth.user.id}/${$event.name}`;

      }
      link.target = '_blank';
      document.body.appendChild(link);
      link.click();
    },

    removeFileUpload(file) {
      this.showHideLoading(true);
      Axios.postMasters({
        route: 'diseases/diseases/deletefilepdf',
        name: file.name,
        nameFile: this.uploadData.nameFile,
        user: this.uploadData.user,
        disease_id: this.model.id,
      }).then(() => {
        this.showHideLoading();
        this.model.fileList = [];
        localStorage.setItem('listFiles', JSON.stringify(this.model.fileList));
      });
    },

    handleSuccess(res, file) {
      file.editFile = true;
      this.model.fileList.push(file);
      this.verifyUpload(file);
      // localStorage.setItem("listFiles", JSON.stringify(this.model.fileList));
      // this.model.other_values.push(this.filesKML[0]);
      // this.loadMap();
    },

    verifyUpload(file) {
      this.showHideLoading(true);
      const isPDF = file.name.includes('.pdf');
      //const isJPG = file.type === 'image/jpeg';
      //const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isPDF) {
        SweetAlert.warning(i18n.t('common_words.pdf_file_warning'));
        this.model.fileList = [];
        localStorage.setItem('listFiles', JSON.stringify(this.model.fileList));
        this.showHideLoading();
      }
      this.showHideLoading();
      return isPDF;
    },

    getNameDisease() {
      if (!sessionStorage.getItem('editForm'))
        this.$emit('getNameDiseaseDigit');
    },

    emitFile(file) {
      this.$emit('setFileFao', file.name);
    },

    fieldFirstLetterUppercase() {
      if (this.model.name) {
        this.model.name = convertFirstLetterUppercase(this.model.name);
      }
      if (this.model.scientific_name) {
        this.model.scientific_name = convertFirstLetterUppercase(
          this.model.scientific_name
        );
      }
    },

    validate() {
      return this.$validator.validateAll().then((res) => {
        if (res) {
          this.fieldFirstLetterUppercase();
          this.$emit('fillDiseaseForm', 'firstStep');
          if (!this.model.type_p_e) {
            this.validationInputsRequired('type');
            return false;
          }
          return res;
        }
      });
    },
  },

  mounted() {
    let editForm = {};
    this.model.color = this.colors; //.hex
    if (this.isUpdate() && sessionStorage.getItem('editForm')) {
      editForm = JSON.parse(sessionStorage.getItem('editForm'));
      this.model.id = editForm.id;
      this.model.name = convertFirstLetterUppercase(editForm.name);
      this.model.observation = editForm.observation;
      this.model.photo = editForm.photo === 1 ? true : false;
      this.model.color = editForm.color ? editForm.color : this.colors;
      this.model.scientific_name = convertFirstLetterUppercase(editForm.scientific_name);
      this.model.confirmation = editForm.confirmation === 1 ? true : false;
      this.colors = editForm.color ? editForm.color : this.colors;
      this.model.perimeter = editForm.perimeter === 1 ? true : false;
      this.model.type_p_e = editForm.type_p_e;
      this.model.type_p_e_name = editForm.type_p_e_name;
      if (editForm.fao_doc) {
        let splited = editForm.fao_doc.split('/');
        this.model.fileList = [{ name: splited[splited.length - 1] }];
      }
      this.forceRerender();
    }
  },
};
</script>
<style scoped>
.uplodadFAOFile {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
</style>
